import { render } from "./DmeApproveScreen.vue?vue&type=template&id=d8a11c94&scoped=true"
import script from "./DmeApproveScreen.vue?vue&type=script&lang=ts"
export * from "./DmeApproveScreen.vue?vue&type=script&lang=ts"

import "./DmeApproveScreen.vue?vue&type=style&index=0&id=d8a11c94&scoped=true&lang=css"
import "./DmeApproveScreen.vue?vue&type=style&index=1&id=d8a11c94&lang=css"
script.render = render
script.__scopeId = "data-v-d8a11c94"

export default script